import { fetchAndActivate, getValue } from "firebase/remote-config";
import { useCallback, useEffect, useState } from "react";
import { getRemoteConfigInstance } from "./firebase";

export interface ReadOnlyModeState {
  readonly isReadOnly: boolean;
}

export function useReadOnlyMode(): ReadOnlyModeState {
  const [isReadOnly, setIsReadOnly] = useState(false);

  const updateReadOnly = useCallback(async () => {
    const remoteConfig = getRemoteConfigInstance();
    if (!remoteConfig) {
      setIsReadOnly(false);
      return;
    }
    try {
      await fetchAndActivate(remoteConfig);
      const value = getValue(remoteConfig, "read_only_mode");
      setIsReadOnly(value.asBoolean());
    } catch {
      setIsReadOnly(false);
    }
  }, []);

  useEffect(() => {
    updateReadOnly();
  }, [updateReadOnly]);

  return { isReadOnly };
}
